
import { Link } from 'react-router-dom';

const Footer = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/905422671171?text=Merhaba%20ben%20lhglobalpass.com%20%C3%BCzerinden%20ileti%C5%9Fime%20ge%C3%A7iyorum', '_blank');
  };

  return (
    <footer className="bg-navy text-white relative overflow-hidden">
      <div className="container mx-auto px-4 lg:px-8 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Column 1: Brand */}
          <div>
            <div className="flex items-center mb-5">
              <img
                src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/b1acd31a7a45ce877b97408cf0eb917c.png"
                alt="LH Global Pass"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm mb-8">
              İzmir'in Güvenilir Vize Danışmanı
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/lhglobalpass"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-gold rounded-full transition-colors duration-300"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.facebook.com/lhglobalpass"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-gold rounded-full transition-colors duration-300"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/lhglobalpass"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-gold rounded-full transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4 className="text-base font-semibold mb-6">Hızlı Linkler</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/" className="text-gray-400 text-sm hover:text-gold transition-colors duration-300">
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-gray-400 text-sm hover:text-gold transition-colors duration-300">
                  Hizmetler
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="text-gray-400 text-sm hover:text-gold transition-colors duration-300">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-gray-400 text-sm hover:text-gold transition-colors duration-300">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Popular Services */}
          <div>
            <h4 className="text-base font-semibold mb-6">Popüler Hizmetler</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/hizmetler" className="text-gray-400 text-sm hover:text-gold transition-colors duration-300">
                  Schengen Vize
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-gray-400 text-sm hover:text-gold transition-colors duration-300">
                  Amerika Vize
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-gray-400 text-sm hover:text-gold transition-colors duration-300">
                  İngiltere Vize
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-gray-400 text-sm hover:text-gold transition-colors duration-300">
                  Oturum Kartı
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-gray-400 text-sm hover:text-gold transition-colors duration-300">
                  E-Vize
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div>
            <h4 className="text-base font-semibold mb-6">İletişim</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-gold mt-1"></i>
                <a href="tel:+905422671171" className="text-gray-400 text-sm hover:text-gold transition-colors duration-300">
                  +90 542 267 11 71
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-gold mt-1"></i>
                <a href="mailto:lhglobalpass@gmail.com" className="text-gray-400 text-sm hover:text-gold transition-colors duration-300">
                  lhglobalpass@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-gold mt-1"></i>
                <span className="text-gray-400 text-sm">
                  Fevzi Paşa Mah. 847/1 Sk. No:8 Kat:4 Daire:4/405 Sağlık İş Hanı Konak/İzmir
                </span>
              </li>
            </ul>
            <button
              onClick={handleWhatsApp}
              className="mt-6 bg-gold hover:bg-gold-dark text-navy px-6 py-2 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp
            </button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 LH Global Pass. Tüm hakları saklıdır. |{' '}
            <Link to="/kvkk" className="hover:text-gold transition-colors duration-300">
              KVKK
            </Link>{' '}
            |{' '}
            <Link to="/cerez-politikasi" className="hover:text-gold transition-colors duration-300">
              Çerez Politikası
            </Link>
            {' '}|{' '}
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-gold transition-colors duration-300"
            >
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
